module.exports = __webpack_public_path__ + "static/oes_online.be3be41f.png";